import { Button } from 'antd';
import styled from 'styled-components';

export const SwitchWrapper = styled.div`
  .ant-switch-checked {
    background-color: ${({ theme }) => theme.primary};
  }
`;

export const Label = styled.div`
  color: #7f7f7f;
  margin-bottom: 2px;
  font-weight: 300;
  font-size: 15px;
`;

export const EnableSection = styled.div<{ isCreateSmartCharging?: boolean }>`
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 24px;
  padding-top: ${({ isCreateSmartCharging }) =>
    isCreateSmartCharging ? 4 : 24}px;

  /* Cor do tenant onde o antd fica no azul padrão (MV2-2006) */
  .ant-btn-link,
  .ant-btn-link:hover,
  .ant-btn-link:focus {
    color: ${({ theme }) => theme.primary};
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-checkbox-checked::after,
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.primary};
  }
`;

export const FlexCenter = styled.div`
  display: flex;
  align-items: center;
`;

export const Legend = styled.div`
  margin-top: 24px;
  padding: 16px;
  font-weight: 300;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
`;

export const LegendAlert = styled(Legend)`
  background-color: #fff9c2;
`;

export const MessageBox = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;

export const EditButton = styled(Button)`
  height: 46px;
`;

export const DeleteButton = styled(EditButton)`
  margin-left: 4px;
`;

// Diferença entre os algoritmos (MV2-2006)
export const AlgorithmHelp = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #f5f7f9;
  font-size: 13px;
  font-weight: 300;
  align-items: flex-start;
`;

// Potência fixa (MV2-2005): antd fica no azul padrão se não tingir pelo tema do tenant
export const FixedPower = styled.div`
  .ant-btn:not([disabled]):hover,
  .ant-btn:not([disabled]):focus,
  .ant-input-affix-wrapper:hover,
  .ant-input-affix-wrapper-focused {
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-btn:not([disabled]):hover,
  .ant-btn:not([disabled]):focus {
    color: ${({ theme }) => theme.primary};
  }

  .ant-input-affix-wrapper-focused {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.primary}33;
  }

  .ant-input-number:hover,
  .ant-input-number-focused,
  .ant-input-number:focus-within {
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-input-number-focused,
  .ant-input-number:focus-within {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.primary}33;
  }
`;

export const PowerCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PowerHint = styled.span<{ $over?: boolean }>`
  color: ${({ $over }) => ($over ? '#ff4d4f' : '#8c8c8c')};
  font-size: 12px;
  white-space: nowrap;
`;

// Quanto do limite (menos a reserva) as potências fixas já ocupam
export const Capacity = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px 32px;
  margin-top: 16px;
`;

export const CapacityRow = styled.div`
  flex: 1 1 200px;
  max-width: 360px;
`;

export const CapacityHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #595959;
  margin-bottom: 4px;

  strong {
    color: #262626;
  }
`;

export const CapacityTrack = styled.div`
  height: 8px;
  border-radius: 4px;
  background: #f0f0f0;
  overflow: hidden;
`;

export const CapacityFill = styled.div<{ $percent: number; $over: boolean }>`
  height: 100%;
  width: ${({ $percent }) => $percent}%;
  border-radius: 4px;
  background: ${({ theme, $over }) => ($over ? '#ff4d4f' : theme.primary)};
  transition: width 0.2s;
`;

export const CapacityNote = styled.div<{ $over: boolean }>`
  margin-top: 4px;
  font-size: 12px;
  color: ${({ $over }) => ($over ? '#ff4d4f' : '#8c8c8c')};
`;

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 20px;
`;

export const ToolbarActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #595959;
`;

export const TableMeta = styled.div`
  margin: 8px 0;
  font-size: 12px;
  color: #8c8c8c;
`;

export const StationName = styled.span`
  font-weight: 500;
  word-break: break-all;
`;
